import { Record } from 'immutable'

const SpoItemRecord = Record({
	id: -1,
	allotted_weight: null,
	category_id: '',
	category_name: '',
	product_id: '',
	product_name: '',
	brand_ordered: '',
	// brands: [],
	tc_available: false,
	target_price: null,
	message: '',
	// is_unknown_product: false,
	input_type: '',
	pending_weight: null,
	grade: null,
	price_per_kg: null,
	hsn_code: null,
	gst: 18, //by default 18
	item_id: null,
})

class SpoEnquiryItem extends SpoItemRecord {
	constructor(data = {}) {
		super({
			...data,
			id: data?.id ?? Math.floor(Math.random() * 1000),
		})
	}
}

export default SpoEnquiryItem
